export default "__VITE_ASSET__CoplsN2c__"